var exports = {
  "k": "x61f99309--695a20--container",
};

module.exports = exports;
